import { isHTTPError, type NetworkError, StreamedHTTPError } from '@atlassian/eoc-global-context';

const mediaTypeRegex =
	/(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;

export const opsReportsErrorTransformer = (e: Error) => {
	if (isHTTPError(e)) {
		const contentType = e.response.headers.get('Content-Type');
		// The content type is application/json, and it is highly likely utf-8 encoded
		if (contentType && mediaTypeRegex.test(contentType)) {
			return e.response.json().then((data) => new StreamedHTTPError(e, data, data.message));
		}
		// For anything else, try to interpret it as utf8 text as best effort.
		return e.response.text().then((message) => new StreamedHTTPError(e, message, message));
	}
	return e as NetworkError;
};
